// extracted by mini-css-extract-plugin
module.exports = {"buttonGroup":"SaveConfigurationModal_buttonGroup__21IjT","infoText":"SaveConfigurationModal_infoText__2BP3k"};